module.exports = __webpack_public_path__ + "static/media/blog-12.e2cfb8d9.svg";